import api from './api';

export async function getPortfolio() {
  const res = await api.get('/api/v-portfolio');
  return res.data;
}

export async function getOrders() {
  const res = await api.get('/api/v-orders');
  return res.data;
}

export async function placeOrder(order) {
  const res = await api.post('/api/v-orders', order);
  return res.data;
}

export async function cancelOrder(orderId) {
  const res = await api.post(`/api/v-orders/cancel/${orderId}`);
  return res.data;
}

export async function getTransactions() {
  const res = await api.get('/api/v-transactions');
  return res.data;
}

export async function getLeaderboard() {
  const res = await api.get('/api/v-leaderboard');
  return res.data;
}

export async function getCoins() {
  const res = await api.get('/api/coins');
  return res.data;
}

export async function getTraderTransactions(userId) {
  const res = await api.get(`/api/v-transactions/${userId}`);
  return res.data;
}

export async function getTraderPortfolio(userId) {
  const res = await api.get(`/api/v-portfolio/${userId}`);
  return res.data;
}

export async function getPortfolioValueHistory() {
  const res = await api.get('/api/v-portfolio/history');
  return res.data;
} 